import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Control, LocalForm} from 'react-redux-form';

class SamlForm extends React.Component {

    buttonClick(ref) {
        ref.click();
    }

    render() {
        const ControlPassword = Control.password;
        const {ssoEndpoint, authnRequest, token} = this.props;
        const divStyle = {
            display: 'none'
        };

        return (
            <div key="SamlForm_1" style={divStyle}>
                <LocalForm action={ssoEndpoint} method="post" >

                    <div className="wdc-form-field">
                        <ControlPassword model="RelayState" id="RelayState" value={token} />
                    </div>
                    <div className="wdc-form-field">
                            <ControlPassword model="SAMLRequest" id="SAMLRequest" value={authnRequest} />
                    </div>
                    <button className="wdc-btn wdc-btn-primary" ref={ref => this.buttonClick(ref)} autoFocus={true}>Continue</button>
                </LocalForm>
            </div>
        );
    }

}

SamlForm.propTypes = {
    ssoEndpoint: PropTypes.string,
    authnRequest: PropTypes.string,
    token: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        ssoEndpoint: state.login.ssoEndpoint,
        authnRequest: state.login.authnRequest,
        token: state.login.token
    };
};

export default connect(mapStateToProps)(SamlForm);
